import { useEffect, useState } from "react"
import { Spinner } from "asocomponents"
import DocumentoService from "../../../../modules/Documentos/application/DocumentoService.js";
import GrillaAdjuntos from "./GrillaAdjuntos.jsx";

function GrillaAdjuntoSiniestro({ nroSiniestro }) {

    const [adjuntos, setAdjuntos] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const obtenerDocumentos = async () => {
        setIsLoading(true)
        const documentosServices = new DocumentoService() 

        let documentos = await documentosServices.getDocumentosSiniestro(nroSiniestro)

        setAdjuntos(documentos)
        setIsLoading(false)
    }

    useEffect(() => {
        nroSiniestro && obtenerDocumentos()
    }, [nroSiniestro])

    if (isLoading) {
        return <Spinner color="red" size="50" />
    } 

    return (
        <GrillaAdjuntos adjuntos={adjuntos} mostrarBotonAcciones={nroSiniestro ? true : false}/>
    )
}

export default GrillaAdjuntoSiniestro